import { useQuery } from '@tanstack/react-query'
import { getGroupMeetings } from '../api/meetingApi'

/** Drill-down: seçili grubun toplantıları (salt-okuma). groupId null ise sorgu devre dışı. */
export function useGroupMeetings(groupId: number | null, page = 0, size = 50, sort?: string) {
  return useQuery({
    queryKey: ['group-meetings', groupId, page, size, sort ?? ''],
    queryFn: () => getGroupMeetings(groupId as number, { page, size, sort }),
    enabled: groupId != null,
  })
}
